module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selling-large-f12bf05ce83826694e0791f91f215cef.svg";